import { render, staticRenderFns } from "./StartSprint.vue?vue&type=template&id=d6ebc4c0&scoped=true&"
import script from "./StartSprint.vue?vue&type=script&lang=ts&"
export * from "./StartSprint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ebc4c0",
  null
  
)

export default component.exports